/// <reference path="./boa-branch-picker-types.d.ts" />
(function () {
  "use strict";

  window.BoaBranchPicker = window.BoaBranchPicker || {};

  // ============================================================================
  // Form Utils
  // ============================================================================
  window.BoaBranchPicker.formUtils = {
    showStep: function (stepName, deliveryMethod = null) {
      const constants = window.BoaBranchPicker.constants;
      const domUtils = window.BoaBranchPicker.domUtils;
      const dateUtils = window.BoaBranchPicker.dateUtils;

      const modal = domUtils.getModal();
      if (!modal) return;

      const stepSelector = constants.STEP_SELECTORS[stepName];
      if (!stepSelector) return;

      const targetStep = modal.querySelector(stepSelector);
      if (!targetStep) return;

      modal
        .querySelectorAll(`${constants.STEP_SELECTOR}.is-visible`)
        .forEach((visibleStep) => visibleStep.classList.remove("is-visible"));

      targetStep.classList.add("is-visible");

      if (stepName !== "date-selection") return;

      const titleElement = targetStep.querySelector(
        "[data-date-selection-title]"
      );
      if (titleElement && deliveryMethod) {
        const titleAttribute =
          deliveryMethod === "pickup"
            ? "data-title-pickup"
            : "data-title-delivery";
        const methodTitle = titleElement.getAttribute(titleAttribute);
        if (methodTitle) titleElement.textContent = methodTitle;
      }

      if (dateUtils?.populateDateValues) {
        dateUtils.populateDateValues();
      }
      const dateInput = domUtils.getInputElement("boa-date");
      if (!dateInput || !dateInput.value) {
        this.hideOptionSpecificFields();
      } else {
        this.showOptionSpecificFields();
      }
    },

    showOptionSpecificFields: function () {
      const constants = window.BoaBranchPicker.constants;
      const domUtils = window.BoaBranchPicker.domUtils;
      const state = window.BoaBranchPicker.state;

      const modal = domUtils.getModal();
      const dateStep = modal?.querySelector(constants.DATE_STEP);
      const optionFieldsContainer = dateStep?.querySelector(
        constants.SELECTORS.optionSpecificFields
      );
      if (
        !modal ||
        !state.getSelectedDeliveryMethod() ||
        !dateStep ||
        !optionFieldsContainer
      )
        return;

      const isPickup = state.getSelectedDeliveryMethod() === "pickup";
      const pickupFields = optionFieldsContainer.querySelector(
        '[data-delivery-method="pickup"]'
      );
      const deliveryFields = optionFieldsContainer.querySelector(
        '[data-delivery-method="delivery"]'
      );
      pickupFields?.classList.toggle("is-visible", isPickup);
      deliveryFields?.classList.toggle("is-visible", !isPickup);

      if (!isPickup) {
        const deliveryFieldsContainer = dateStep.querySelector(
          '[data-delivery-method="delivery"]'
        );
        if (deliveryFieldsContainer)
          this.updateRecipientTypeButtons(deliveryFieldsContainer);
      }

      optionFieldsContainer.classList.remove(
        "boa-branch-picker__option-specific-fields--hidden"
      );
      setTimeout(() => this.updateSubmitButtonState(), 0);
    },

    hideOptionSpecificFields: function () {
      const constants = window.BoaBranchPicker.constants;
      const domUtils = window.BoaBranchPicker.domUtils;

      const modal = domUtils.getModal();
      if (!modal) return;

      const optionFieldsContainer = modal
        .querySelector(constants.DATE_STEP)
        ?.querySelector(constants.SELECTORS.optionSpecificFields);
      if (optionFieldsContainer) {
        optionFieldsContainer.classList.add(
          "boa-branch-picker__option-specific-fields--hidden"
        );
      }
    },

    updateRecipientTypeButtons: function (recipientTypeContainer) {
      const constants = window.BoaBranchPicker.constants;

      const recipientTypeOptions = recipientTypeContainer.querySelectorAll(
        constants.SELECTORS.recipientType
      );
      const selectedOption = recipientTypeContainer.querySelector(
        `${constants.SELECTORS.recipientType}.is-selected`
      );
      recipientTypeOptions.forEach((option) => {
        const isSelected = option === selectedOption;
        const shouldDisable = selectedOption && !isSelected;
        if (option instanceof HTMLButtonElement)
          option.disabled = shouldDisable;
        option.toggleAttribute("data-disabled", shouldDisable);
      });
    },

    getVisibleRequiredFields: function (form) {
      const constants = window.BoaBranchPicker.constants;
      const state = window.BoaBranchPicker.state;

      const dateStep = form.querySelector(constants.DATE_STEP);
      const visibleStep = form.querySelector(
        `${constants.STEP_SELECTOR}.is-visible`
      );

      return Array.from(form.querySelectorAll("[required]")).filter(
        (requiredField) => {
          if (requiredField.disabled) return false;

          const fieldStep = requiredField.closest(constants.STEP_SELECTOR);
          if (fieldStep && fieldStep !== dateStep && fieldStep !== visibleStep)
            return false;

          const addressFields = requiredField.closest("[data-address-type]");
          if (
            addressFields?.classList.contains(
              "boa-branch-picker__address-fields--hidden"
            )
          )
            return false;

          const optionFieldsContainer = requiredField.closest(
            constants.SELECTORS.optionSpecificFields
          );
          if (
            optionFieldsContainer?.classList.contains(
              "boa-branch-picker__option-specific-fields--hidden"
            )
          )
            return false;

          if (optionFieldsContainer) {
            const deliveryMethodContainer = requiredField.closest(
              '[data-delivery-method="pickup"], [data-delivery-method="delivery"]'
            );
            if (deliveryMethodContainer) {
              if (!deliveryMethodContainer.classList.contains("is-visible"))
                return false;
              const deliveryMethod = deliveryMethodContainer.getAttribute(
                "data-delivery-method"
              );
              if (deliveryMethod !== state.getSelectedDeliveryMethod())
                return false;
            }
          }

          return true;
        }
      );
    },

    checkFormValidity: function (form) {
      const domUtils = window.BoaBranchPicker.domUtils;
      const state = window.BoaBranchPicker.state;

      const dateInput = domUtils.getInputElement("boa-date");
      const regionInput = domUtils.getInputElement("boa-pickup-region");
      const branchInput = domUtils.getInputElement("boa-pickup-branch");
      const modal = domUtils.getModal();
      const cityInput = domUtils.getInputElement("boa-delivery-city");
      const streetInput = domUtils.getInputElement("boa-delivery-street");
      const hospitalInput = domUtils.getInputElement("boa-delivery-hospital");
      const departmentInput = domUtils.getInputElement(
        "boa-delivery-department"
      );

      if (!form) return false;

      if (!state.getSelectedDeliveryMethod()) return false;

      if (!dateInput || !dateInput.value) {
        return false;
      }

      if (state.getSelectedDeliveryMethod() === "pickup") {
        const hasRegion = regionInput && regionInput.value?.trim();
        const hasBranch = branchInput && branchInput.value?.trim();
        return hasRegion && hasBranch;
      } else if (state.getSelectedDeliveryMethod() === "delivery") {
        const recipientType = modal
          ?.querySelector("[data-recipient-type].is-selected")
          ?.getAttribute("data-recipient-type");

        if (!recipientType) return false;

        if (recipientType === "private") {
          // House number is optional.
          const hasCity = cityInput && cityInput.value?.trim();
          const hasStreet = streetInput && streetInput.value?.trim();
          return hasCity && hasStreet;
        } else if (recipientType === "hospital") {
          const hasHospital = hospitalInput && hospitalInput.value?.trim();
          const hasDepartment =
            departmentInput && departmentInput.value?.trim();
          return hasHospital && hasDepartment;
        }
      }

      return false;
    },

    validateForm: function (form) {
      if (!form) return false;
      const visibleRequiredFields = this.getVisibleRequiredFields(form);
      for (const requiredField of visibleRequiredFields) {
        if (!requiredField.value?.trim()) {
          if (requiredField.reportValidity) {
            requiredField.reportValidity();
          } else {
            requiredField.focus();
          }
          return false;
        }
      }
      return true;
    },

    updateSubmitButtonState: function () {
      const form = document.getElementById("boa-branch-picker-form");
      if (!form) return;
      const submitButtons = form.querySelectorAll(".form__submit");
      const isValid = this.checkFormValidity(form);
      submitButtons.forEach((submitButton) => {
        if (submitButton instanceof HTMLButtonElement) {
          submitButton.disabled = !isValid;
          // Keep aria-disabled in lockstep so assistive tech (and the Equally AI
          // overlay, which mirrors disabled into aria-disabled once at init) never
          // reports a stale disabled state on an actionable button.
          if (isValid) {
            submitButton.removeAttribute("aria-disabled");
          } else {
            submitButton.setAttribute("aria-disabled", "true");
          }
        }
      });
    },

    // address1 stays the combined "street number" string the cart, checkout prefill and
    // carrier service already expect; street/houseNumber go to Verifone unparsed.
    getPrivateAddressParts: function (formData) {
      const city = String(formData.get("boa_city") || "").trim();
      const street = String(formData.get("boa_street") || "").trim();
      const houseNumber = String(formData.get("boa_house_number") || "").trim();

      return {
        city: city,
        street: street,
        houseNumber: houseNumber,
        address1: houseNumber ? `${street} ${houseNumber}` : street,
      };
    },

    buildPayload: function (formData, recipientType) {
      const constants = window.BoaBranchPicker.constants;
      const state = window.BoaBranchPicker.state;

      const payload = { date: formData.get("date") };
      if (state.getSelectedDeliveryMethod() === "pickup") {
        const branchInput = document.getElementById("boa-pickup-branch");
        const branchSelect = branchInput?.closest(
          constants.SELECTORS.customSelect
        );
        const branchValue = formData.get("branch");
        const branchDisplayName =
          branchSelect
            ?.querySelector(constants.SELECTORS.customValue)
            ?.textContent?.trim()
            .replace(/\s+/g, " ") || "";
        payload.selfPickup = {
          regionVerifoneId: String(formData.get("region") || ""),
          regionMetaobjectId: String(
            formData.get("region_metaobject_id") || ""
          ),
          branchVerifoneId: String(branchValue || ""),
          branchMetaobjectId: String(
            formData.get("branch_metaobject_id") || ""
          ),
          branchDisplayName,
        };
      } else if (recipientType === "private") {
        const addressParts = this.getPrivateAddressParts(formData);
        payload.privateAddress = {
          city: addressParts.city,
          address1: addressParts.address1,
          street: addressParts.street,
        };
        if (addressParts.houseNumber) {
          payload.privateAddress.houseNumber = addressParts.houseNumber;
        }
      } else if (recipientType === "hospital") {
        const building = formData.get("building");
        const floor = formData.get("floor");
        payload.hospitalAddress = {
          hospitalName: String(formData.get("hospital") || ""),
          department: String(formData.get("department") || ""),
          building: building ? String(building) : undefined,
          floor: floor ? String(floor) : undefined,
        };
      }
      return payload;
    },

    buildAttributesFormData: function (formData, recipientType) {
      const state = window.BoaBranchPicker.state;

      const attributesFormData = new FormData();
      attributesFormData.append(
        "attributes[delivery_date]",
        String(formData.get("date") || "")
      );
      const addressType =
        state.getSelectedDeliveryMethod() === "pickup"
          ? "pickup"
          : recipientType === "private"
          ? "delivery"
          : "hospital";
      attributesFormData.append("attributes[address_type]", addressType);

      if (state.getSelectedDeliveryMethod() === "pickup") {
        attributesFormData.append(
          "attributes[region_metaobject_id]",
          String(formData.get("region_metaobject_id") || "")
        );
      } else if (recipientType === "private") {
        const addressParts = this.getPrivateAddressParts(formData);
        attributesFormData.append(
          "attributes[private_address_city]",
          addressParts.city
        );
        attributesFormData.append(
          "attributes[private_address_address1]",
          addressParts.address1
        );
      } else if (recipientType === "hospital") {
        attributesFormData.append(
          "attributes[hospital_name]",
          String(formData.get("hospital") || "")
        );
        attributesFormData.append(
          "attributes[hospital_department]",
          String(formData.get("department") || "")
        );
        const building = formData.get("building");
        const floor = formData.get("floor");
        if (building)
          attributesFormData.append(
            "attributes[hospital_building]",
            String(building)
          );
        if (floor)
          attributesFormData.append(
            "attributes[hospital_floor]",
            String(floor)
          );
      }
      return { attributesFormData, addressType };
    },

    clearOtherAddressTypeAttributes: function (
      attributesFormData,
      currentAddressType
    ) {
      const attributesByType = {
        pickup: ["region_metaobject_id"],
        delivery: ["private_address_city", "private_address_address1"],
        hospital: [
          "hospital_name",
          "hospital_department",
          "hospital_building",
          "hospital_floor",
        ],
      };

      Object.entries(attributesByType).forEach(([addressType, attributes]) => {
        if (addressType !== currentAddressType) {
          attributes.forEach((attribute) => {
            attributesFormData.append(`attributes[${attribute}]`, "");
          });
        }
      });
    },

    resetForm: function () {
      const constants = window.BoaBranchPicker.constants;
      const domUtils = window.BoaBranchPicker.domUtils;
      const state = window.BoaBranchPicker.state;
      const selectUtils = window.BoaBranchPicker.selectUtils;
      const addressUtils = window.BoaBranchPicker.addressUtils;
      const responseUI = window.BoaBranchPicker.responseUI;

      const modal = domUtils.getModal();
      const formElement = document.getElementById("boa-branch-picker-form");
      if (!modal || !(formElement instanceof HTMLFormElement)) return;

      state.setSelectedDeliveryMethod(null);
      state.getDatePickerInstance()?.hide();

      formElement.reset();
      formElement.classList.remove("is-disabled");

      const dateDisplay = domUtils.getInputElement("boa-date-display");
      if (dateDisplay) {
        dateDisplay.value = "";
        dateDisplay.closest(".input")?.classList.remove("is-filled");
      }

      document
        .querySelectorAll(constants.SELECTORS.dateOption)
        .forEach((btn) => btn.classList.remove("is-selected"));

      this.showStep("initial");

      const regionInput = domUtils.getInputElement("boa-pickup-region");
      const branchInput = domUtils.getInputElement("boa-pickup-branch");
      const regionCustomSelect = regionInput?.closest(
        constants.SELECTORS.customSelect
      );
      const branchCustomSelect = branchInput?.closest(
        constants.SELECTORS.customSelect
      );

      if (regionCustomSelect && regionInput) {
        selectUtils.resetCustomSelectValue(regionCustomSelect, regionInput);
        regionCustomSelect.closest(".input")?.classList.remove("is-filled");
      }

      if (branchCustomSelect && branchInput) {
        selectUtils.resetCustomSelectValue(branchCustomSelect, branchInput);
        selectUtils.setFieldState(branchInput, branchCustomSelect, false);
        branchCustomSelect.removeAttribute("data-selected-region");
        branchCustomSelect.closest(".input")?.classList.remove("is-filled");
        branchCustomSelect
          .querySelectorAll(
            `${constants.SELECTORS.customOption}[data-region-id]`
          )
          .forEach((opt) => opt.removeAttribute("data-visible"));
      }

      addressUtils.resetAddressFields(modal, "private");
      addressUtils.resetAddressFields(modal, "hospital");

      modal
        .querySelectorAll(constants.SELECTORS.recipientType)
        .forEach((btn) => {
          btn.classList.remove("is-selected");
          btn.removeAttribute("data-disabled");
          if (btn instanceof HTMLButtonElement) {
            btn.disabled = false;
          }
        });

      modal
        .querySelectorAll(constants.SELECTORS.addressFields)
        .forEach((fields) => {
          fields.classList.add("boa-branch-picker__address-fields--hidden");
        });

      modal
        .querySelector(constants.DATE_STEP)
        ?.querySelector(constants.SELECTORS.optionSpecificFields)
        ?.classList.add("boa-branch-picker__option-specific-fields--hidden");

      selectUtils.closeAllSelects();
      responseUI.hideResponseUI();
      this.updateSubmitButtonState();
    },
  };

  // ============================================================================
  // Event Handlers
  // ============================================================================
  window.BoaBranchPicker.eventHandlers = {
    handleDeliveryMethodClick: function (event) {
      const domUtils = window.BoaBranchPicker.domUtils;
      const state = window.BoaBranchPicker.state;
      const formUtils = window.BoaBranchPicker.formUtils;

      const deliveryMethodOption = event.target.closest(
        "[data-delivery-method]"
      );
      const modal = domUtils.getModal();

      if (!deliveryMethodOption || !modal) return;

      event.preventDefault();
      event.stopPropagation();
      state.setSelectedDeliveryMethod(
        deliveryMethodOption.getAttribute("data-delivery-method")
      );
      formUtils.showStep("date-selection", state.getSelectedDeliveryMethod());
    },

    handleBackButton: function (event) {
      const domUtils = window.BoaBranchPicker.domUtils;
      const state = window.BoaBranchPicker.state;
      const formUtils = window.BoaBranchPicker.formUtils;

      const backButton = event.target.closest('[data-action="back"]');
      const modal = domUtils.getModal();

      if (!backButton || !modal) return;

      event.preventDefault();
      event.stopPropagation();
      state.setSelectedDeliveryMethod(null);
      formUtils.showStep("initial");
    },

    handleDateOptionClick: function (event) {
      const state = window.BoaBranchPicker.state;
      const dateUtils = window.BoaBranchPicker.dateUtils;

      const dateOptionButton = event.target.closest("[data-date-option]");
      const selectedDate = dateOptionButton?.getAttribute("data-date-value");

      if (!dateOptionButton || !selectedDate) return;

      if (
        dateOptionButton.hasAttribute("data-disabled") ||
        (dateOptionButton instanceof HTMLButtonElement &&
          dateOptionButton.disabled)
      ) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      const datePickerInstance = state.getDatePickerInstance();
      if (datePickerInstance) {
        const selectedDateValue = new Date(selectedDate + "T00:00:00");
        datePickerInstance.setDate(selectedDateValue);
        dateUtils.handleDateSelection(selectedDateValue);
      }
    },

    handleDateInputChange: function (event) {
      const state = window.BoaBranchPicker.state;
      const dateUtils = window.BoaBranchPicker.dateUtils;

      const dateInput = event.target;
      if (
        !(dateInput instanceof HTMLInputElement) ||
        dateInput.id !== "boa-date"
      )
        return;

      const datePickerInstance = state.getDatePickerInstance();
      if (dateInput.value && datePickerInstance) {
        if (dateUtils.suppressSetDate) return;
        const dateValue = new Date(dateInput.value + "T00:00:00");
        if (!isNaN(dateValue.getTime())) {
          datePickerInstance.setDate(dateValue);
        }
      } else {
        dateUtils.updateDateDisplay(dateInput);
      }
    },

    handleRegionChange: function (event) {
      const constants = window.BoaBranchPicker.constants;
      const domUtils = window.BoaBranchPicker.domUtils;
      const selectUtils = window.BoaBranchPicker.selectUtils;
      const formUtils = window.BoaBranchPicker.formUtils;

      const regionInput = event.target;
      const branchInput = document.getElementById("boa-pickup-branch");
      const branchCustomSelect = branchInput?.closest(
        constants.SELECTORS.customSelect
      );
      const dropdown = branchCustomSelect?.querySelector(
        constants.SELECTORS.customDropdown
      );
      if (
        regionInput?.id !== "boa-pickup-region" ||
        branchInput?.id !== "boa-pickup-branch" ||
        !branchCustomSelect ||
        !dropdown
      )
        return;

      const regionValue = regionInput.value;
      const branchOptions = dropdown.querySelectorAll(
        `${constants.SELECTORS.customOption}[data-region-id]`
      );
      const previousRegion = branchCustomSelect.getAttribute(
        "data-selected-region"
      );

      if (regionValue) {
        selectUtils.setFieldState(branchInput, branchCustomSelect, true);
        branchCustomSelect.setAttribute("data-selected-region", regionValue);

        if (previousRegion && previousRegion !== regionValue) {
          const branchMetaobjectInput = domUtils.getInputElement(
            constants.IDS.branchMetaobjectId
          );
          if (branchMetaobjectInput instanceof HTMLInputElement) {
            branchMetaobjectInput.value = "";
          }
          selectUtils.resetCustomSelectValue(branchCustomSelect, branchInput);
          branchCustomSelect.closest(".input")?.classList.remove("is-filled");
        }

        branchOptions.forEach((option) => {
          option.toggleAttribute(
            "data-visible",
            option.getAttribute("data-region-id") === regionValue
          );
        });
      } else {
        selectUtils.setFieldState(branchInput, branchCustomSelect, false);
        branchCustomSelect.removeAttribute("data-selected-region");
        [
          constants.IDS.regionMetaobjectId,
          constants.IDS.branchMetaobjectId,
        ].forEach((id) => {
          const input = domUtils.getInputElement(id);
          if (input) input.value = "";
        });
        branchOptions.forEach((option) =>
          option.removeAttribute("data-visible")
        );
        selectUtils.resetCustomSelectValue(branchCustomSelect, branchInput);
        branchCustomSelect.closest(".input")?.classList.remove("is-filled");
      }
      formUtils.updateSubmitButtonState();
    },

    handleRecipientTypeClick: function (event) {
      const constants = window.BoaBranchPicker.constants;
      const domUtils = window.BoaBranchPicker.domUtils;
      const addressUtils = window.BoaBranchPicker.addressUtils;
      const responseUI = window.BoaBranchPicker.responseUI;
      const formUtils = window.BoaBranchPicker.formUtils;

      const recipientTypeOption = event.target.closest("[data-recipient-type]");
      const recipientType = recipientTypeOption?.getAttribute(
        "data-recipient-type"
      );
      const modal = domUtils.getModal();
      const dateStep = modal?.querySelector(constants.DATE_STEP);
      const addressFields = dateStep?.querySelector(
        `[data-address-type="${recipientType}"]`
      );
      if (
        !recipientTypeOption ||
        (recipientTypeOption instanceof HTMLButtonElement &&
          recipientTypeOption.disabled) ||
        recipientTypeOption.hasAttribute("data-disabled") ||
        !recipientType ||
        !modal ||
        !dateStep ||
        !addressFields
      )
        return;

      const isCurrentlyExpanded = !addressFields.classList.contains(
        "boa-branch-picker__address-fields--hidden"
      );
      const allRecipientTypeOptions = dateStep.querySelectorAll(
        constants.SELECTORS.recipientType
      );
      const otherOptions = Array.from(allRecipientTypeOptions).filter(
        (option) => option !== recipientTypeOption
      );

      if (isCurrentlyExpanded) {
        addressFields.classList.add(
          "boa-branch-picker__address-fields--hidden"
        );
        recipientTypeOption.classList.remove("is-selected");
        addressUtils.resetAddressFields(modal, recipientType);
        responseUI.hideResponseUI();
        otherOptions.forEach((option) => {
          if (option instanceof HTMLButtonElement) option.disabled = false;
          option.removeAttribute("data-disabled");
        });
      } else {
        modal
          .querySelectorAll(constants.SELECTORS.addressFields)
          .forEach((addressFieldsContainer) =>
            addressFieldsContainer.classList.add(
              "boa-branch-picker__address-fields--hidden"
            )
          );
        allRecipientTypeOptions.forEach((option) =>
          option.classList.remove("is-selected")
        );
        addressFields.classList.remove(
          "boa-branch-picker__address-fields--hidden"
        );
        recipientTypeOption.classList.add("is-selected");
        otherOptions.forEach((option) => {
          if (option instanceof HTMLButtonElement) option.disabled = true;
          option.setAttribute("data-disabled", "");
        });
        addressUtils.enableRecipientFields(recipientType, dateStep);
      }
      formUtils.updateSubmitButtonState();
    },

    handleCustomSelectClick: function (event) {
      const constants = window.BoaBranchPicker.constants;
      const selectUtils = window.BoaBranchPicker.selectUtils;

      const customTrigger = event.target.closest(
        constants.SELECTORS.customTrigger
      );
      const customOption = event.target.closest(
        constants.SELECTORS.customOption
      );

      if (customTrigger && !customTrigger.disabled) {
        const customSelect = customTrigger.closest(
          constants.SELECTORS.customSelect
        );
        if (customSelect) {
          event.stopPropagation();
          selectUtils.toggleSelect(customSelect);
        }
      } else if (customOption) {
        const customSelect = customOption.closest(
          constants.SELECTORS.customSelect
        );
        if (customSelect) {
          event.stopPropagation();
          selectUtils.selectOption(customSelect, customOption, true);
        }
      }
    },

    handleSearchableSelectClick: function (event) {
      const constants = window.BoaBranchPicker.constants;
      const selectUtils = window.BoaBranchPicker.selectUtils;

      const searchableTrigger = event.target.closest(
        constants.SELECTORS.searchableTrigger
      );
      const searchableOption = event.target.closest(
        constants.SELECTORS.searchableOption
      );

      if (searchableTrigger && !searchableTrigger.disabled) {
        const searchableSelect = searchableTrigger.closest(
          constants.SELECTORS.searchableSelect
        );
        if (searchableSelect) {
          event.stopPropagation();
          selectUtils.toggleSelect(searchableSelect);
        }
      } else if (searchableOption) {
        let searchableSelect = searchableOption.closest(
          constants.SELECTORS.searchableSelect
        );
        if (!searchableSelect) {
          const addressDropdown = searchableOption.closest(
            "[data-address-dropdown]"
          );
          if (addressDropdown) {
            const wrapper = addressDropdown.closest(
              ".boa-branch-picker__recipient-type-wrapper"
            );
            const searchType = addressDropdown.getAttribute(
              "data-address-dropdown"
            );
            searchableSelect = wrapper?.querySelector(
              `[data-search-type="${searchType}"]`
            );
          }
        }
        if (searchableSelect) {
          event.stopPropagation();
          selectUtils.selectOption(searchableSelect, searchableOption, false);
          const searchType = searchableSelect.getAttribute("data-search-type");
          if (searchType === "hospital")
            selectUtils.handleHospitalSelection(searchableOption);
        }
      }
    },

    handleAddressInputFocus: function (event) {
      const constants = window.BoaBranchPicker.constants;
      const selectUtils = window.BoaBranchPicker.selectUtils;

      const searchInput = event.target;
      if (!searchInput?.hasAttribute("data-search-input")) return;
      const searchableSelect = searchInput.closest(
        constants.SELECTORS.searchableSelect
      );
      const searchType = searchableSelect?.getAttribute("data-search-type");
      if (
        selectUtils.isTypeaheadSearch(searchType) &&
        !searchableSelect.hasAttribute("data-disabled") &&
        !searchableSelect.hasAttribute("data-open")
      ) {
        selectUtils.closeAllSelects();
        selectUtils.openSelect(searchableSelect);
      }
    },

    // City and street get is-filled from selectOption; the house number is a plain input, so
    // without this its floating label sits on top of the digits.
    handleHouseNumberInput: function (event) {
      const constants = window.BoaBranchPicker.constants;

      const houseNumberInput = event.target;
      if (
        !(houseNumberInput instanceof HTMLInputElement) ||
        houseNumberInput.id !== constants.IDS.houseNumberInput
      ) {
        return;
      }
      houseNumberInput
        .closest(".input")
        ?.classList.toggle("is-filled", Boolean(houseNumberInput.value.trim()));
    },

    handleSearchableSelectSearch: function (event) {
      const constants = window.BoaBranchPicker.constants;
      const selectUtils = window.BoaBranchPicker.selectUtils;

      const searchInput = event.target;
      if (!searchInput?.hasAttribute("data-search-input")) return;
      const searchableSelect = searchInput.closest(
        constants.SELECTORS.searchableSelect
      );
      const searchType = searchableSelect?.getAttribute("data-search-type");
      if (searchType) {
        // Typing over a chosen value invalidates it, otherwise the hidden input would keep
        // submitting the previous selection (and streets would stay scoped to the old city).
        if (selectUtils.isTypeaheadSearch(searchType)) {
          const hiddenInput = searchableSelect.querySelector(
            "input[type='hidden']"
          );
          if (
            hiddenInput instanceof HTMLInputElement &&
            hiddenInput.value &&
            hiddenInput.value !== searchInput.value.trim()
          ) {
            hiddenInput.value = "";
            searchableSelect.closest(".input")?.classList.remove("is-filled");
            if (searchType === "city") {
              window.BoaBranchPicker.addressUtils?.clearStreet();
            }
            window.BoaBranchPicker.formUtils?.updateSubmitButtonState();
          }
        }
        selectUtils.loadSearchResults(
          searchableSelect,
          searchInput.value.trim(),
          searchType
        );
      }
    },

    handleFormInputChange: function () {
      const responseUI = window.BoaBranchPicker.responseUI;
      responseUI.hideResponseUI();
    },

    handleFormSubmit: async function (event) {
      const domUtils = window.BoaBranchPicker.domUtils;
      const state = window.BoaBranchPicker.state;
      const formUtils = window.BoaBranchPicker.formUtils;
      const responseUI = window.BoaBranchPicker.responseUI;

      // Bound to both click and submit. On a native submit the target is the form itself, so
      // resolving only via the button would skip preventDefault and let the page GET-navigate.
      const submitButton = event.target.closest?.(".form__submit");
      const form =
        submitButton?.closest("form") ||
        (event.type === "submit" ? event.target : null);
      const modal = domUtils.getModal();
      const recipientTypeElement = modal?.querySelector(
        "[data-recipient-type].is-selected"
      );
      if (form?.getAttribute("id") !== "boa-branch-picker-form") return;

      event.preventDefault();
      event.stopPropagation();
      if (!formUtils.validateForm(form)) return;

      form.classList.add("is-disabled");
      responseUI.showResponseLoading();

      const formData = new FormData(form);
      if (state.getSelectedDeliveryMethod())
        formData.append("deliveryMethod", state.getSelectedDeliveryMethod());
      const recipientType = recipientTypeElement?.getAttribute(
        "data-recipient-type"
      );
      if (recipientType) formData.append("recipientType", recipientType);

      const payload = formUtils.buildPayload(formData, recipientType);
      const { attributesFormData, addressType } =
        formUtils.buildAttributesFormData(formData, recipientType);

      try {
        const response = await fetch("/apps/proxy/branch/availability", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        });
        const availabilityData = await response.json();
        if (!availabilityData?.success) {
          const strings = window["themeVariables"].strings;
          const translatedMessage = {
            "This store is closed for pickup on the selected date":
              strings.branchPickerErrorClosedPickup,
            "Store is closed for orders on the selected date":
              strings.branchPickerErrorClosedDelivery,
            "Site is experiencing high load":
              strings.branchPickerErrorOverload,
          }[availabilityData?.message];
          responseUI.showResponseError(
            translatedMessage ||
              availabilityData?.message ||
              strings.branchPickerErrorServer
          );
          return;
        }
        const {
          isAvailable,
          branchVerifoneId,
          branchMetaobjectId,
          deliveryPrice,
          deliveryTimeFrame,
          zipCode,
          isSpecialDate,
        } = availabilityData;

        if (!isAvailable) {
          responseUI.showResponseError(
            window["themeVariables"].strings.branchPickerErrorAvailability
          );
          return;
        }
        attributesFormData.append(
          "attributes[branch_verifone_id]",
          String(branchVerifoneId || "")
        );
        attributesFormData.append(
          "attributes[branch_metaobject_id]",
          String(branchMetaobjectId || "")
        );
        attributesFormData.append(
          "attributes[delivery_price]",
          String(deliveryPrice || "")
        );
        attributesFormData.append(
          "attributes[delivery_time_frame]",
          String(deliveryTimeFrame || "")
        );
        attributesFormData.append(
          "attributes[zip_code]",
          String(zipCode || "")
        );
        attributesFormData.append(
          "attributes[is_special_date]",
          String(isSpecialDate || "")
        );

        formUtils.clearOtherAddressTypeAttributes(
          attributesFormData,
          addressType
        );
        const cartUpdateResponse = await fetch(
          window["Shopify"].routes.root + "cart/update.js",
          {
            method: "POST",
            body: attributesFormData,
          }
        );
        const cartUpdateData = await cartUpdateResponse.json();

        document.documentElement.dispatchEvent(
          new CustomEvent("cart:updated", {
            bubbles: true,
            detail: {
              cart: cartUpdateData,
            },
          })
        );

        document.documentElement.dispatchEvent(
          new CustomEvent("cart:refresh", {
            bubbles: true,
            detail: {
              cart: cartUpdateData,
            },
          })
        );

        document.documentElement.dispatchEvent(
          new CustomEvent("branch:selected", {
            bubbles: true,
            detail: {
              cart: cartUpdateData,
            },
          })
        );

        responseUI.showResponseSuccess();

        if (
          state.getSelectedDeliveryMethod() === "delivery" &&
          recipientType === "private" &&
          cartUpdateData?.token
        ) {
          const addressParts = formUtils.getPrivateAddressParts(formData);
          await fetch("/apps/proxy/delivery-address", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              cartId: cartUpdateData.token,
              address: {
                address1: addressParts.address1,
                city: addressParts.city,
              },
            }),
          });
        }
      } catch (error) {
        responseUI.showResponseError(
          error.message ||
            window["themeVariables"].strings.branchPickerErrorServer
        );
      } finally {
        form.classList.remove("is-disabled");
      }
    },
  };

  // ============================================================================
  // Main Initialization
  // ============================================================================
  let coreReady = false;
  let utilsReady = false;

  function checkModulesReady() {
    if (
      !coreReady &&
      window.BoaBranchPicker.constants &&
      window.BoaBranchPicker.state &&
      window.BoaBranchPicker.domUtils &&
      window.BoaBranchPicker.responseUI
    ) {
      coreReady = true;
    }
    if (
      !utilsReady &&
      window.BoaBranchPicker.dateUtils &&
      window.BoaBranchPicker.selectUtils &&
      window.BoaBranchPicker.cartUtils
    ) {
      utilsReady = true;
    }
  }

  function init() {
    const constants = window.BoaBranchPicker.constants;
    const domUtils = window.BoaBranchPicker.domUtils;
    const dateUtils = window.BoaBranchPicker.dateUtils;
    const selectUtils = window.BoaBranchPicker.selectUtils;
    const cartUtils = window.BoaBranchPicker.cartUtils;
    const eventHandlers = window.BoaBranchPicker.eventHandlers;

    if (!dateUtils || !selectUtils || !cartUtils || !eventHandlers) {
      const missing = [];
      if (!dateUtils) missing.push("dateUtils");
      if (!selectUtils) missing.push("selectUtils");
      if (!cartUtils) missing.push("cartUtils");
      if (!eventHandlers) missing.push("eventHandlers");
      console.error(
        "BoaBranchPicker: Required modules not available. Missing:",
        missing.join(", "),
        ". Ensure boa-branch-picker-core.js and boa-branch-picker-utils.js are loaded before boa-branch-picker.js"
      );
      return;
    }

    const modal = domUtils.getModal();
    if (!modal) return;

    window["boaBranchPicker"] = {
      open: function () {
        modal.setAttribute("open", "");
      },
      close: function () {
        modal.removeAttribute("open", "");
      },
    };

    modal.addEventListener("openable-element:close", () => {
      const formUtils = window.BoaBranchPicker.formUtils;
      if (formUtils?.resetForm) {
        formUtils.resetForm();
      }
    });

    document.addEventListener("cart:updated", function (event) {
      const cart = event["detail"].cart;
      cartUtils.updateCartItemProperties(cart);
    });

    dateUtils.populateDateValues();
    dateUtils.initDatePicker();
    dateUtils.syncDateDisplayOnBlur();

    modal.addEventListener("click", eventHandlers.handleDeliveryMethodClick);
    modal.addEventListener("click", eventHandlers.handleBackButton);
    modal.addEventListener("click", eventHandlers.handleDateOptionClick);
    modal.addEventListener("change", eventHandlers.handleDateInputChange);
    modal.addEventListener("change", eventHandlers.handleRegionChange);
    modal.addEventListener("click", eventHandlers.handleRecipientTypeClick);
    modal.addEventListener("click", eventHandlers.handleCustomSelectClick);
    modal.addEventListener("click", eventHandlers.handleSearchableSelectClick);
    modal.addEventListener("input", eventHandlers.handleSearchableSelectSearch);
    modal.addEventListener("input", eventHandlers.handleHouseNumberInput);
    modal.addEventListener("focusin", eventHandlers.handleAddressInputFocus);
    modal.addEventListener("submit", eventHandlers.handleFormSubmit);
    modal.addEventListener("click", eventHandlers.handleFormSubmit);

    document.addEventListener("click", (event) => {
      if (!(event.target instanceof HTMLElement)) return;
      if (
        !event.target.closest(constants.SELECTORS.customSelect) &&
        !event.target.closest(constants.SELECTORS.searchableSelect) &&
        !event.target.closest("[data-address-dropdown]")
      ) {
        selectUtils.closeAllSelects();
      }
    });

    // The theme's focus trap closes the picker on Escape from its own document listener;
    // capture runs first, so an open dropdown swallows the press whatever the order is.
    document.addEventListener(
      "keydown",
      (event) => {
        if (event.key !== "Escape" && event.key !== "Esc") return;
        // A typeahead keeps data-open while its panel is hidden (empty query, no matches),
        // so only swallow Escape when something is actually on screen to close.
        const openSelect = Array.from(
          modal.querySelectorAll(
            `${constants.SELECTORS.customSelect}[data-open], ${constants.SELECTORS.searchableSelect}[data-open]`
          )
        ).find((select) => {
          const searchType = select.getAttribute("data-search-type");
          return (
            !selectUtils.isTypeaheadSearch(searchType) ||
            selectUtils
              .getTypeaheadDropdown(select)
              ?.hasAttribute("data-open")
          );
        });
        if (!openSelect) return;
        event.preventDefault();
        event.stopPropagation();
        selectUtils.closeSelect(openSelect);
      },
      true
    );

    modal.addEventListener("keydown", (event) => {
      if (!(event.target instanceof HTMLElement)) return;
      const select = event.target.closest(
        `${constants.SELECTORS.customSelect}, ${constants.SELECTORS.searchableSelect}`
      );
      if (!select) return;

      const searchType = select.getAttribute("data-search-type");
      if (
        !selectUtils.isTypeaheadSearch(searchType) ||
        !selectUtils.getTypeaheadDropdown(select)?.hasAttribute("data-open")
      ) {
        return;
      }

      if (event.key === "ArrowDown" || event.key === "ArrowUp") {
        event.preventDefault();
        selectUtils.moveTypeaheadActive(
          select,
          event.key === "ArrowDown" ? 1 : -1
        );
      } else if (event.key === "Enter") {
        // Always swallow Enter here: without it the form submits the moment the customer
        // presses it to pick an option.
        event.preventDefault();
        // Without an arrow press there is no active option; Enter takes the first match.
        const activeOption =
          selectUtils.getActiveTypeaheadOption(select) ||
          selectUtils.getTypeaheadOptions(select)[0];
        if (activeOption) {
          selectUtils.selectOption(select, activeOption, false);
        }
      }
    });

    const form = document.getElementById("boa-branch-picker-form");
    const formUtils = window.BoaBranchPicker.formUtils;
    if (form) {
      form.addEventListener("input", () => formUtils.updateSubmitButtonState());
      form.addEventListener("change", () =>
        formUtils.updateSubmitButtonState()
      );
      form.addEventListener("input", eventHandlers.handleFormInputChange);
      form.addEventListener("change", eventHandlers.handleFormInputChange);
      setTimeout(() => formUtils.updateSubmitButtonState(), 100);
    }

    const modalContent = modal.querySelector(".modal__content");
    if (modalContent) {
      let scrollbarTimeout;
      const showScrollbar = () => {
        modalContent.classList.add("show-scrollbar");
        clearTimeout(scrollbarTimeout);
        scrollbarTimeout = setTimeout(() => {
          modalContent.classList.remove("show-scrollbar");
        }, 2000);
      };
      modalContent.addEventListener("focusin", showScrollbar);
      modalContent.addEventListener("scroll", showScrollbar);

      let lastScrollHeight = modalContent.scrollHeight;
      const checkAndScroll = () => {
        requestAnimationFrame(() => {
          const currentScrollHeight = modalContent.scrollHeight;
          if (currentScrollHeight > lastScrollHeight) {
            modalContent.scrollTop = modalContent.scrollHeight;
          }
          lastScrollHeight = currentScrollHeight;
        });
      };

      const resizeObserver = new ResizeObserver(checkAndScroll);
      resizeObserver.observe(modalContent);

      const responseEl = modalContent.querySelector(
        ".boa-branch-picker__response"
      );
      const addressFields = modalContent.querySelectorAll(
        ".boa-branch-picker__address-fields"
      );

      if (responseEl) resizeObserver.observe(responseEl);
      addressFields.forEach((fields) => resizeObserver.observe(fields));
    }
  }

  function tryInit() {
    checkModulesReady();
    if (coreReady && utilsReady) {
      init();
    }
  }

  document.addEventListener("boa-branch-picker:core-ready", function () {
    coreReady = true;
    tryInit();
  });

  document.addEventListener("boa-branch-picker:utils-ready", function () {
    utilsReady = true;
    tryInit();
  });

  checkModulesReady();
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", tryInit);
  } else {
    tryInit();
  }
})();

document.documentElement.addEventListener('branch:selected', async (event) => {
  if(window.boaCatalogPopupHandleBranchSelected){
    await window.boaCatalogPopupHandleBranchSelected?.(event);
  }
  if(window.handleFeaturedCollectionsByBranch){
    await window.handleFeaturedCollectionsByBranch?.(event);
  }
});
